import { createReducer } from 'typesafe-actions'
import { setActiveRenderImgIdxState, resetActiveRenderImgIdx } from '../actions/app/renderImages.actions'

export const defaultState = null

const activeRenderImgIdxReducer = createReducer(defaultState)
    .handleAction(setActiveRenderImgIdxState, (state, action) => action.payload)
    .handleAction(resetActiveRenderImgIdx, () => defaultState)

export default activeRenderImgIdxReducer
